export class GroupMemberStatus {
  static waitingForApprove = 'waiting_for_approval';
  static waitingForAdminApprove = 'waiting_for_admin_approval';
  static joined = 'joined';
}

export class GroupLevel {
  static admin = 'admin';
  static moderator = 'moderator';
  static member = 'member';
}

export class SubType {
  static PUBLIC = 'public';
  static PUBLIC_RESTRICTED = 'publicly_restricted'
}
